import React from "react";
import LocalSeoPage from "./LocalSeoPage";

export default function VoyanceMontelimarPage() {
  return (
    <LocalSeoPage
      path="/voyance-montelimar"
      service={{
        name: "Voyance",
        slug: "voyance",
        shortName: "voyance",
        kicker: "Voyance à Montélimar (Drôme)",
        h1: "Voyance à Montélimar — Guidance, médiumnité et clarté pour ta vie",
        lead:
          "Tu cherches des réponses sur ton avenir, ton couple, ton travail ou ton chemin de vie ? Je te propose des consultations de voyance et de médiumnité à Montélimar (20 quai du Roubion), ou à distance partout en France. Une démarche bienveillante, précise et sans jugement.",
        image: "https://www.bilan2vie.fr/og-voyance.jpg",
        priceFrom: 45,
        aboutTitle: "Qu'est-ce qu'une consultation de voyance ?",
        audienceTitle: "À qui s'adresse une consultation de voyance à Montélimar ?",
      }}
      meta={{
        title: "Voyance à Montélimar — Médium et guidance spirituelle | Bilan 2 Vie",
        description:
          "Consultations de voyance et médiumnité à Montélimar (Drôme) et à distance. Guidance amour, travail, famille, chemin de vie. Cabinet 20 quai du Roubion, 26200 Montélimar. 4,9/5 sur 139 avis Google.",
        keywords:
          "voyance Montélimar, voyant Montélimar, médium Montélimar, voyance Drôme, guidance spirituelle, voyance à distance, cabinet de voyance 26200",
      }}
      about={[
        "La voyance est un mode de perception qui permet de capter des informations sur le passé, le présent et le futur d'une personne, en dehors des cinq sens habituels. Ce n'est ni de la magie, ni un tour de passe-passe : c'est une sensibilité particulière, une écoute fine du subtil. À Montélimar, j'utilise principalement les cartes (tarot, oracles), mon ressenti intuitif et ma médiumnité pour t'apporter des réponses claires.",
        "Une consultation de voyance n'est pas faite pour te dicter ta vie. Tu restes maître de tes choix. Ce que je perçois, ce sont les énergies en mouvement, les pistes qui se dessinent et les blocages qui freinent ton évolution. Le but : te donner suffisamment d'éléments pour avancer en conscience, avec discernement et sérénité.",
        "À Montélimar, je reçois en cabinet privé au cœur du centre-ville, dans un espace pensé pour que tu te sentes en confiance dès la première minute. La consultation dure entre 45 minutes et 1h selon la formule choisie. Pour les personnes qui ne peuvent pas se déplacer (Drôme provençale, Ardèche, Vaucluse, ou plus loin en France), les consultations à distance par téléphone ou visio sont tout aussi efficaces.",
        "La voyance peut se conjuguer avec la médiumnité (contact avec les défunts ou les guides), la numérologie (analyse des cycles de vie via les chiffres) ou un Bilan de Vie complet. Je choisis avec toi la formule la plus adaptée à ta demande lors de la prise de rendez-vous.",
      ]}
      audience={[
        "Tu vis une période de doute ou de changement (rupture, reconversion, déménagement).",
        "Tu as une question précise sur ta vie amoureuse, professionnelle ou familiale.",
        "Tu sens qu'un blocage te freine sans savoir d'où il vient.",
        "Tu veux comprendre les schémas qui se répètent dans ta vie.",
        "Tu cherches confirmation d'un ressenti ou d'une intuition.",
        "Tu habites Montélimar, Pierrelatte, Donzère, Valence, Avignon, Le Pouzin, ou ailleurs en Drôme/Ardèche.",
        "Tu préfères une consultation à distance, par téléphone ou en visio.",
      ]}
      steps={[
        {
          title: "Prise de rendez-vous",
          desc:
            "Tu réserves en ligne via le module de réservation (présentiel à Montélimar ou à distance). Tu choisis la formule : consultation standard (30 min, 45 €) ou guidance approfondie (1h, 70 €).",
        },
        {
          title: "Accueil & mise en énergie",
          desc:
            "Le jour J, je te reçois dans mon cabinet à Montélimar (20 quai du Roubion), à 2 min du parking gratuit du Roubion. On prend un instant pour que tu te poses, on échange brièvement sur ce qui t'amène, puis je centre mes énergies.",
        },
        {
          title: "Consultation",
          desc:
            "Je tire les cartes et te transmets ce que je perçois, sans complaisance mais avec bienveillance. Tu peux poser toutes tes questions au fil de la séance. Je te donne ce que je vois, ce que je ressens — et je ne brode jamais pour combler un vide.",
        },
        {
          title: "Synthèse & pistes concrètes",
          desc:
            "On termine par une synthèse claire : les énergies en présence, les leviers à activer, les écueils à éviter. Tu repars avec des pistes actionnables pour les semaines et mois à venir.",
        },
      ]}
      reasons={[
        "Guillaume, médium et voyant reconnu (4,9/5 sur 139 avis Google), explore la spiritualité depuis 2015 et en a fait son métier depuis 2021. Formé au tarot, à la médiumnité et au Pranic Healing.",
        "Cabinet en centre-ville de Montélimar, accessible en 5 minutes depuis la sortie d'autoroute A7 et à 2 minutes à pied du parking gratuit du Roubion.",
        "Approche éthique : pas de prédictions effrayantes, pas de dépendance créée. Je t'aide à reprendre les rênes de ta vie, pas à dépendre de moi.",
        "Réservation en ligne 24h/24, créneaux visibles en direct, confirmation immédiate par e-mail.",
        "Consultations à distance (téléphone, WhatsApp, visio) tout aussi précises que le présentiel — idéal si tu habites loin de Montélimar.",
        "Confidentialité absolue. Ce qui se dit en séance reste entre nous, toujours.",
      ]}
      faqs={[
        {
          q: "Combien coûte une consultation de voyance à Montélimar ?",
          a: "Les tarifs démarrent à 45 € pour une consultation de 30 minutes, et 70 € pour 1 heure. Tous les tarifs sont visibles sur la page Services au moment de la réservation.",
        },
        {
          q: "Une consultation à distance est-elle aussi efficace qu'en présentiel ?",
          a: "Oui, totalement. La voyance et la médiumnité fonctionnent par connexion énergétique, indépendamment de la distance physique. Beaucoup de mes consultations se font par téléphone ou visio, avec des clients en Drôme, en Ardèche, en région parisienne ou même à l'étranger.",
        },
        {
          q: "Faut-il préparer quelque chose avant la séance ?",
          a: "Rien de spécial. Arrive avec tes questions, ton ressenti et ton ouverture. Si tu souhaites des réponses concernant une personne en lien avec toi (conjoint, ex, proche…), c'est utile d'avoir avec toi une photo de cette personne et, si possible, sa date de naissance.",
        },
        {
          q: "Combien de temps à l'avance puis-je connaître mon avenir ?",
          a: "Je vois en général sur un an, mois par mois. Au-delà, les énergies deviennent floues car ton libre arbitre et tes choix continuent de façonner le futur. Pour cette même raison, je te conseille de ne pas revenir consulter avant 4 à 6 mois : laisse les énergies se déployer entre deux séances.",
        },
        {
          q: "Vous déplacez-vous en dehors de Montélimar ?",
          a: "Pour les consultations individuelles, je reçois au cabinet à Montélimar. Pour les événements (soirées voyance, salons), je me déplace partout en Drôme, Ardèche et Vaucluse. N'hésite pas à me contacter pour un événement privé.",
        },
        {
          q: "Comment réserver ?",
          a: "Directement en ligne via le bouton « Réserver une séance » en haut de cette page. Tu choisis le créneau qui te convient et tu reçois une confirmation immédiate par e-mail.",
        },
      ]}
      blogCategory="Voyance"
    />
  );
}
